import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SignupPreviewService } from '../components/dinamic-signup/services/signup-preview.service';
import { PREVIEW_CHECK_DOCUMENT } from '../components/dinamic-signup/constants/preview-empresa.fixtures';

export interface CheckDocumentDto {
  country: 'CL' | 'VE';
  documentNumber: string;
  documentType: 'RUT' | 'RUN' | 'CCVE';
}

/**
 * Respuesta de `person-registration/check-document`. No dice de quién es el
 * documento (R5): el back solo informa si está registrado.
 */
export interface CheckDocumentResponse {
  isRegistered: boolean;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class PersonRegistrationService {
  private baseUrl = environment.apiNest;

  constructor(
    private http: HttpClient,
    private preview: SignupPreviewService
  ) {}

  /**
   * Verifica si un documento ya esta registrado en el sistema
   * @param data Datos del documento a verificar
   * @returns Respuesta indicando si el documento esta registrado
   */
  async checkDocument(data: CheckDocumentDto): Promise<CheckDocumentResponse> {
    if (this.preview.activo) {
      return PREVIEW_CHECK_DOCUMENT;
    }

    const url = `${this.baseUrl}public/person-registration/check-document`;
    // Sin `skip`: se manda el JWT de la sesión (el usuario ya inició sesión en
    // el paso del OTP de email). El back exige estar autenticado (A7/B2).
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return firstValueFrom(
      this.http.post<CheckDocumentResponse>(url, data, { headers })
    );
  }
}
